import { PositionAndWindAnimationSVG } from "./PositionAndWindAnimationSVG";
export default PositionAndWindAnimationSVG;
